module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Light.7140aa7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Light.eot
// module id = qG6D
// module chunks = 6